import { ReactNode } from "react";
import { IRmaListTab } from "../../../../../services/api/rma-list-service";

interface ITabButtonProps {
    tabId: IRmaListTab;
    isActive: boolean;
    disabled: boolean;
    onSelect: (tab: IRmaListTab) => void;
    children: ReactNode;
}

const TabButton = ({ tabId, isActive, disabled, onSelect, children }: ITabButtonProps) => (
    <button
        type="button"
        role="tab"
        aria-selected={isActive}
        className={`rma-list-tabs-bar__tab${isActive ? " rma-list-tabs-bar__tab--active" : ""}`}
        disabled={disabled}
        onClick={() => onSelect(tabId)}
    >
        {children}
    </button>
);

export default TabButton;